/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

// let authData;

var Login = (function (_Component) {
	_inherits(Login, _Component);

	function Login() {
		var _this = this;

		_classCallCheck(this, Login);

		_Component.apply(this, arguments);

		this.state = {
			errorMessage: null,
			validatingLogin: false,
			username: '',
			password: ''
		};

		this.handleLogin = function () {
			_this.setState({ validatingLogin: true });

			var fullPath = _srcSettings2['default'].protocol + ':' + _srcSettings2['default'].cdn + 'wp-json/jwt-auth/v1/token';
			_jquery2['default'].post(fullPath, {
				username: _this.state.username,
				password: _this.state.password
			}).done(function (data) {
				_this.setState({
					errorMessage: null,
					successMessage: 'You are now logged in.',
					validatingLogin: false
				});
				localStorage.setItem('authData', JSON.stringify(data));
			}).fail(function (data) {
				_this.setState({
					errorMessage: data.responseJSON.message,
					successMessage: null,
					validatingLogin: false
				});
			});
		};
	}

	Login.prototype.render = function render() {
		var _classNames,
		    _this2 = this;

		var styles = require('./Login.css');

		var submitClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Button] = true, _classNames[styles['Button--validating']] = this.state.validatingLogin, _classNames));

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Login' }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				this.state.successMessage && _react2['default'].createElement(
					'div',
					{ className: styles.SuccessMessage },
					this.state.successMessage
				),
				!this.state.successMessage && _react2['default'].createElement(
					'fieldset',
					null,
					this.state.errorMessage && _react2['default'].createElement(
						'div',
						{ className: styles.ErrorMessage },
						this.state.errorMessage
					),
					_react2['default'].createElement(
						'div',
						{ className: styles.Field },
						_react2['default'].createElement('input', {
							disabled: this.state.validatingLogin,
							type: 'text',
							placeholder: 'Username',
							value: this.state.username,
							onChange: function (event) {
								_this2.setState({ username: event.target.value });
							} })
					),
					_react2['default'].createElement(
						'div',
						{ className: styles.Field },
						_react2['default'].createElement('input', {
							disabled: this.state.validatingLogin,
							type: 'password',
							placeholder: 'Password',
							value: this.state.password,
							onChange: function (event) {
								_this2.setState({ password: event.target.value });
							} })
					),
					_react2['default'].createElement(
						'div',
						{ className: styles.Field },
						_react2['default'].createElement(
							'button',
							{
								className: submitClasses,
								onClick: this.handleLogin },
							'Log in',
							this.state.validatingLogin && _react2['default'].createElement(_reactLoader2['default'], {
								className: 'spinner',
								color: 'rgb(255, 78, 61)',
								corners: 0,
								direction: 1,
								hwaccel: true,
								left: '50%',
								length: 6,
								lines: 13,
								opacity: 0.1,
								radius: 7,
								rotate: 13,
								scale: 1.00,
								shadow: false,
								speed: 2,
								top: '50%',
								trail: 60,
								width: 2,
								zIndex: 2e9 })
						)
					)
				)
			)
		);
	};

	return Login;
})(_react.Component);

exports['default'] = Login;
module.exports = exports['default'];

// componentDidMount() {
// 	authData = JSON.parse(localStorage.getItem('authData'));
// }
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.js
 ** module id = 703
 ** module chunks = 0
 **/